import combine from "./combine";
import resolveValue from "./utils/resolveValue";
export var lazyLoadCallback = function (callback) { return ({ kind: "lazyLoadCallback", callback: callback }); };
export var propsCallback = function (callback) { return ({ kind: "propsCallback", callback: callback }); };
export var stateCallback = function (callback) { return ({ kind: "stateCallback", callback: callback }); };
export var childContextCallback = function (callback) { return ({ kind: "childContextCallback", callback: callback }); };
export var skipCallback = function (callback) { return ({ kind: "skipCallback", callback: callback }); };
export var renderCallback = function (callback) { return ({ kind: "renderCallback", callback: callback }); };
export var componentWillMountCallback = function (callback) { return ({ kind: "componentWillMountCallback", callback: callback }); };
export var componentDidMountCallback = function (callback) { return ({ kind: "componentDidMountCallback", callback: callback }); };
export var componentWillUnmountCallback = function (callback) { return ({ kind: "componentWillUnmountCallback", callback: callback }); };
export var componentWillReceivePropsCallback = function (callback) { return ({ kind: "componentWillReceivePropsCallback", callback: callback }); };
export var shouldComponentUpdateCallback = function (callback) { return ({ kind: "shouldComponentUpdateCallback", callback: callback }); };
export var componentWillUpdateCallback = function (callback) { return ({ kind: "componentWillUpdateCallback", callback: callback }); };
export var componentDidUpdateCallback = function (callback) { return ({ kind: "componentDidUpdateCallback", callback: callback }); };
export function createBlueprint() {
    var composables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        composables[_i] = arguments[_i];
    }
    var componentCallbacks = combine.apply(void 0, composables);
    return {
        staticCallbacks: componentCallbacks.filter(function (c) { return c.staticCallback; }).map(function (c) { return c.staticCallback; }),
        instanceCallbacks: function () {
            var result = [];
            componentCallbacks.forEach(function (c) {
                if (!c.instanceCallbacks) {
                    return;
                }
                var instanceCallbacks = resolveValue(c.instanceCallbacks);
                if (!instanceCallbacks) {
                    return;
                }
                result.push.apply(result, instanceCallbacks);
            });
            return result;
        },
    };
}

//# sourceMappingURL=blueprint.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/blueprint.js
// module id = 0
// module chunks = 0